import template from './remove-items-dialog.html';
export var RemoveItemsDialogComponent = {
    template: template,
    bindings: {
        removingItems: '<',
        itemsCount: '<'
    },
    controller: /** @class */ (function () {
        function RemoveItemsDialogComponent($mdDialog) {
            'ngInject';
            this.$mdDialog = $mdDialog;
        }
        RemoveItemsDialogComponent.prototype.closeDialog = function () {
            this.$mdDialog.hide();
        };
        return RemoveItemsDialogComponent;
    }())
};
//# sourceMappingURL=remove-items-dialog.component.js.map